(ns sci.impl.opts
  {:no-doc true}
  (:require
   #?(:cljs [goog.string])
   [sci.impl.namespaces :as namespaces]
   [sci.impl.types]
   [sci.impl.utils :as utils :refer [strip-core-ns]]
   #?(:cljd [sci.lang :as lang] :default [sci.lang]))
  #?@(:cljd [] :clj [(:import
                      [sci.impl.types ICustomType])]))

#?(:clj
   (defrecord Env [namespaces imports load-fn]))

(def namespace-syms (keys namespaces/namespaces))

(defn init-env! [env aliases namespaces classes raw-classes imports
                 load-fn #?(:cljs async-load-fn) #?(:cljs js-libs) ns-aliases]
  (swap! env (fn [env]
               (let [env-nss (:namespaces env)
                     namespaces (merge-with merge
                                            (or
                                             ;; either the env has already got namespaces
                                             env-nss
                                             ;; or we need to install the default namespaces
                                             namespaces/namespaces)
                                            namespaces)
                     aliases (merge aliases
                                    (get-in env [:namespaces 'user :aliases]))
                     namespaces (-> namespaces
                                    (update 'user assoc :aliases aliases)
                                    (update 'clojure.core assoc
                                            ;; no hierarchies on cljd, like the host
                                            #?@(:cljd []
                                                :default ['global-hierarchy
                                                          (utils/new-var 'global-hierarchy (make-hierarchy)
                                                                         {:ns utils/clojure-core-ns})])
                                            '*loaded-libs* (namespaces/loaded-libs**
                                                            (concat (keys env-nss)
                                                                    namespace-syms))))
                     imports (if-let [env-imports (:imports env)]
                               (merge env-imports imports)
                               imports)
                     ns-aliases (merge (:ns-aliases env) ns-aliases)
                     #?@(:cljs [js-libs (merge (:js-libs env) js-libs)])]
                 ;; TODO: is the first case ever hit?
                 (if-not env
                   #?(:clj (->Env namespaces imports load-fn)
                      :default {:namespaces namespaces
                                :imports imports
                                :load-fn load-fn
                                #?@(:cljs [:async-load-fn async-load-fn])})
                   (assoc env
                          :namespaces namespaces
                          :imports imports
                          :load-fn load-fn
                          #?@(:cljs [:async-load-fn async-load-fn
                                     :js-libs js-libs])
                          :public-class (:public-class classes)
                          :class->opts (:class->opts classes)
                          #?@(:cljd [:type->opts (:type->opts classes)])
                          :raw-classes raw-classes
                          :ns-aliases ns-aliases))))))

(defn process-permissions [prev-perms & permissions]
  (not-empty (into prev-perms (comp cat (map strip-core-ns)) permissions)))

(def default-classes
  ;; no runtime reflection on Dart, each class carries :constructor and :instance? closures
  #?(:cljd {'Exception {:class Exception
                        :constructor (fn [msg] (Exception. msg))
                        :instance? (fn [x] (instance? Exception x))}
            'Error {:class Error
                    :instance? (fn [x] (instance? Error x))}
            'ArgumentError {:class ArgumentError
                            :constructor (fn [msg] (ArgumentError. msg))
                            :instance? (fn [x] (instance? ArgumentError x))}
            'StateError {:class StateError
                         :constructor (fn [msg] (StateError. msg))
                         :instance? (fn [x] (instance? StateError x))}
            'Object {:class Object
                     :instance? (fn [x] (some? x))}
            ;; bare int/double/bool compile to cast fns on cljd,
            ;; runtimeType yields the canonical Type objects
            'dart.core.String {:class String
                               :instance? (fn [x] (string? x))}
            'dart.core.num {:instance? (fn [x] (number? x))}
            'dart.core.int {:class (.-runtimeType 1)
                            :instance? (fn [x] (int? x))}
            'dart.core.double {:class (.-runtimeType 1.0)
                               :instance? (fn [x] (double? x))}
            'dart.core.bool {:class (.-runtimeType true)
                             :instance? (fn [x] (boolean? x))}
            'StringBuffer {:class StringBuffer
                           :constructor (fn ([] (StringBuffer.))
                                          ([s] (StringBuffer. s)))
                           :instance? (fn [x] (instance? StringBuffer x))}
            'cljd.core.ExceptionInfo {:class cljd.core/ExceptionInfo
                                      :instance? (fn [x] (instance? cljd.core/ExceptionInfo x))}
            'sci.lang.Type lang/Type}
     :clj {'java.lang.AssertionError AssertionError
           'java.lang.Exception {:class Exception}
           'java.lang.IllegalArgumentException java.lang.IllegalArgumentException
           'clojure.lang.Delay clojure.lang.Delay
           'clojure.lang.ExceptionInfo clojure.lang.ExceptionInfo
           'clojure.lang.LineNumberingPushbackReader clojure.lang.LineNumberingPushbackReader
           'clojure.lang.LazySeq clojure.lang.LazySeq
           'java.lang.String {:class String}
           'java.io.StringWriter java.io.StringWriter
           'java.io.StringReader java.io.StringReader
           'java.lang.Integer Integer
           'java.lang.Number Number
           'java.lang.Double Double
           'java.lang.ArithmeticException ArithmeticException
           'java.lang.Object Object
           'sci.lang.IVar sci.lang.IVar ;; deprecated
           'sci.lang.Type sci.lang.Type
           'sci.lang.Var sci.lang.Var}
     :cljs {'Error {:class js/Error :constructor (fn
                                                   ([msg] (js/Error. msg))
                                                   ([msg filename] (js/Error. msg filename))
                                                   ([msg filename line] (js/Error. msg filename line)))}
            ;; this is here to satisfy the queue reader literal + advanced compilation
            'cljs.core.PersistentQueue.EMPTY cljs.core/PersistentQueue.EMPTY
            'goog.string.StringBuffer {:class goog.string/StringBuffer
                                       :constructor #(goog.string/StringBuffer. %)}
            'sci.lang.Type sci.lang.Type}))

(def default-imports
  #?(:cljd '{Exception Exception
             Error Error
             ArgumentError ArgumentError
             StateError StateError
             Object Object
             StringBuffer StringBuffer
             ExceptionInfo cljd.core.ExceptionInfo
             String dart.core.String
             num dart.core.num
             int dart.core.int
             double dart.core.double
             bool dart.core.bool}
     :clj '{AssertionError java.lang.AssertionError
            Exception java.lang.Exception
            String java.lang.String
            ArithmeticException java.lang.ArithmeticException
            Integer java.lang.Integer
            Number java.lang.Number
            Double java.lang.Double
            Object java.lang.Object}
     :cljs {}))

(defn stringify-keys [m]
  (persistent!
   (reduce-kv (fn [m k v]
                (assoc! m (name k) v)) (transient {}) m)))

(comment
  (stringify-keys {:foo 1})
  )

(defn normalize-classes [classes]
  (loop [class->opts (transient (select-keys classes [:allow]))
         kvs classes]
    (if-let [[sym class-opts] (first kvs)]
      (recur ;; storing the physical class as key didn't work well with GraalVM
       (if (map? class-opts)
         (if-let [sm (:static-methods class-opts)]
           (-> (assoc! class->opts sym class-opts)
               (assoc! :static-methods (assoc (:static-methods class->opts) sym sm)))
           (assoc! class->opts sym class-opts))
         (assoc! class->opts sym {:class class-opts}))
       (rest kvs))
      (let [co (persistent! class->opts)]
        {:public-class (:public-class classes)
         :class->opts co
         ;; cljd has no reflection and Type names are not stable under AOT
         ;; obfuscation, so interop dispatches on the :class Type object itself
         #?@(:cljd [:type->opts (reduce-kv
                                 (fn [m _ opts]
                                   (if-let [c (when (map? opts) (:class opts))]
                                     (assoc m c opts)
                                     m))
                                 {} co)])}))))

(def default-reify-fn
  #?(:cljd (fn [_])
     :clj (fn [{:keys [interfaces methods protocols]}]
            (reify
              Object
              (toString [this]
                ((get methods 'toString) this))
              ICustomType
              (getInterfaces [_this]
                interfaces)
              (getMethods [_this]
                methods)
              (getProtocols [_this]
                protocols)
              (getFields [_this]
                nil)))
     :cljs (fn [_ _ _])))

;; The fields after interrupt-fn are nil at init time and assoc'd during
;; analysis. Declared as record fields because assoc with a non-field key
;; copies the record AND rebuilds its extmap on every call — recur-target
;; alone is assoc'd several times per analyzed form (analyze-children-tail).
#?(:clj (defrecord Ctx [bindings env
                        features readers
                        reload-all
                        check-permissions
                        interrupt-fn
                        unrestricted
                        recur-target
                        params
                        parents
                        closure-bindings
                        fn-expr]))

(defn ->ctx [bindings env features readers check-permissions? & {:keys [interrupt-fn]}]
  #?(:clj (->Ctx bindings env features readers false check-permissions? interrupt-fn
                 nil nil nil nil nil nil)
     :default {:bindings bindings
               :env env
               :features features
               :readers readers
               :check-permissions check-permissions?
               :interrupt-fn interrupt-fn}))

(def default-ns-aliases
  #?(:cljd {;; in SCI the core namespace is always called clojure.core
            'cljd.core 'clojure.core}
     :clj {}
     :cljs {;; in SCI the core namespace is always called clojure.core
            'cljs.core 'clojure.core}))

(defn init
  "Initializes options"
  [{:keys [bindings env
           allow deny
           aliases
           namespaces
           classes
           imports
           features
           load-fn
           readers
           reify-fn
           proxy-fn
           deftype-fn
           interrupt-fn
           unrestricted
           #?(:cljs async-load-fn)
           #?(:cljs js-libs)
           ns-aliases]}]
  (let [env (or env (atom {}))
        imports (merge default-imports imports)
        ns-aliases (merge default-ns-aliases ns-aliases)
        raw-classes (merge default-classes classes)
        classes (normalize-classes raw-classes)
        namespaces (cond-> namespaces
                     bindings (merge {'user (assoc bindings :obj utils/user-ns)}))
        _ (init-env! env aliases namespaces classes raw-classes imports
                     load-fn #?(:cljs async-load-fn) #?(:cljs js-libs) ns-aliases)
        ctx (assoc (->ctx {} env features readers (or allow deny)
                          :interrupt-fn interrupt-fn)
                   :allow (when allow (process-permissions #{} allow))
                   :deny (when deny (process-permissions #{} deny))
                   :reify-fn (or reify-fn default-reify-fn)
                   :proxy-fn proxy-fn
                   :deftype-fn deftype-fn
                   :unrestricted unrestricted
                   #?@(:clj [:main-thread-id (.getId (Thread/currentThread))]))]
    ctx))

(defn merge-opts [ctx opts]
  (let [!env (:env ctx)
        env @!env
        {:keys [bindings
                allow deny
                aliases
                namespaces
                classes
                imports
                features
                load-fn
                readers
                reify-fn
                deftype-fn
                #?(:cljs async-load-fn)
                #?(:cljs js-libs)
                ns-aliases]
         :or {load-fn (:load-fn env)
              #?@(:cljs [async-load-fn (:async-load-fn env)])
              features (:features ctx)}} opts
        raw-classes (merge (:raw-classes @!env) classes)
        classes (normalize-classes raw-classes)
        namespaces (cond-> namespaces
                     bindings (merge {'user (assoc bindings :obj utils/user-ns)}))
        _ (init-env! !env aliases namespaces classes raw-classes imports load-fn #?(:cljs async-load-fn) #?(:cljs js-libs) ns-aliases)
        interrupt-fn (if (contains? opts :interrupt-fn) (:interrupt-fn opts) (:interrupt-fn ctx))
        unrestricted (if (contains? opts :unrestricted) (:unrestricted opts) (:unrestricted ctx))
        ctx (assoc (->ctx {} !env features readers (or (:check-permissions ctx) allow deny)
                          :interrupt-fn interrupt-fn)
                   :allow (when allow (process-permissions (:allow ctx) allow))
                   :deny (when deny (process-permissions (:deny ctx) deny))
                   :reify-fn reify-fn
                   :deftype-fn deftype-fn
                   :unrestricted unrestricted
                   :main-thread-id (:main-thread-id ctx))]
    ctx))
